<template>

  <div>
    <span
      v-if="validType === 'text'">{{ value }}</span>
    <span
      style="white-space: pre-wrap;"
      v-if="validType === 'textarea'">{{ value }}</span>
    <span
      v-if="validType === 'radio'">{{ value }}</span>
    <span
      v-if="validType === 'checkbox'">{{ value.join(', ') }}</span>
    <span
      v-if="validType === 'date'">{{ $d(new Date(value), 'dayMonthYearNum') }}</span>
    <span
      v-if="validType === 'number'">{{ value }}</span>
  </div>

</template>

<script>
import moment from 'moment'

export default {
  name: 'ValueCustomField',
  props: [
    'value',
    'type'
  ],
  data () {
    return {
    }
  },
  computed: {
    validType () {
      if (this.type === 'text' && typeof (this.value) === 'string') {
        return 'text'
      } else if (this.type === 'textarea' && typeof (this.value) === 'string') {
        return 'textarea'
      } else if (this.type === 'radio' && typeof (this.value) === 'string') {
        return 'radio'
      } else if (this.type === 'checkbox' && Array.isArray(this.value)) {
        return 'checkbox'
      } else if (this.type === 'date' && moment(this.value).isValid()) {
        return 'date'
      } else if (this.type === 'number') {
        return 'number'
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/ValueCustomField.vue